import { useState, useRef, useEffect } from 'react';

import StyledWrapper from './style';

import Tooltip from '@mui/material/Tooltip';

const ListItemNavText = ({ text }) => {
	const [isOverflowing, setIsOverflowing] = useState(false);
	const navTextRef = useRef(null);

	useEffect(() => {
		if (navTextRef.current) {
			setIsOverflowing(navTextRef.current.scrollWidth > navTextRef.current.clientWidth);
		}
	}, [text]);

	return (
		<Tooltip title={isOverflowing ? text : ''} arrow placement="top">
			<StyledWrapper.NavText ref={navTextRef}>{text}</StyledWrapper.NavText>
		</Tooltip>
	);
};

export default ListItemNavText;
